/**
 * @file
 * A JavaScript file containing the scroll button functionalities.
 *
 */

/**
 * Enter Espoo JS.
 */
(function (Drupal, $) {
  Drupal.behaviors.scrollButton = {
    attach: function (context) {
      init();
    }
  };

  function init() {
    let container = $('.field-hero, .frontpage-hero-wrapper');
    let button = '#scroll-down-button';
    let scrollToPosition = container.position().top + container.innerHeight() - 60;

    Drupal.behaviors.utils.scrollTrigger(button, "down", scrollToPosition);
  }

})(Drupal, jQuery);
